<template>
	<resource-list-item-skeleton :divided="props.divided" image title subtitle>
		<paragraph-skeleton small/>
		<skeleton :height="16" :width="110" rounded/>

		<div class="flex justify-between items-center mt-10 mb-4">
			<skeleton :height="14" :width="90" rounded/>

			<skeleton :height="20" :width="34" rounded class="mr-16"/>
		</div>
	</resource-list-item-skeleton>
</template>

<script setup lang="ts">
const props = defineProps<{
	divided?: boolean,
}>();
</script>

